<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import { BUS } from "@/utils/bus";
import { isZyapp, commandHandler, showCloseIcon, exchangeSession, isMobile } from "@/utils/modulesForApp"
export default {
	data() {
        return {
            FrontPage:'',
        }
    },
	async created() {
		// localStorage.setItem("FrontPage", this.$route.query.frontPage);
		this.initShare();
		// this.initFrontPage();
		if (!isMobile()) {
			let lang = this.getUrlParams('lang') || "zh-cn";
			this.$i18n.locale = lang;
		}
		BUS.$on("appSetting", res => {
			const language = (res && res.language && res.language.toLowerCase()) || "zh-cn";
			localStorage.setItem("locale", language);
			this.$i18n.locale = language;
			document.title = this.$t("router.title");
		});
		if (isZyapp()) {
			showCloseIcon();
			const userData = await exchangeSession() || {};
			this.$store.commit('login', userData);
			this.commit({
				type: "initUser",
				userInfo
			});
		}
	},
	mounted() {

	},
	methods: {
		initShare() {
			if (isZyapp()) {
				commandHandler({
					type: "menu",
					params: [{
						title: "分享",
						image: "https://lib.cmbi.info/Share%403x.png",
						link: "zyaction://share"
					}]
				})
			}
		},
		// initFrontPage() {
		// 	this.$nextTick(() => {
		// 		this.FrontPage = this.$route.query.frontPage || localStorage.getItem("FrontPage");
		// 		if(this.FrontPage == 'undefined'){
		// 			let str = decodeURI(window.location.href)
		// 			let newStr = str.slice(str.indexOf('?frontPage=')+11)
		// 			if(newStr.indexOf('&') != -1){
		// 				this.FrontPage = newStr.slice(0,newStr.indexOf('&'))
		// 			}else{
		// 				this.FrontPage = newStr
		// 			}
		// 		}
		// 	})
		// }
		getUrlParams(paras) {
            const url = location.href;
            const paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
            let paraObj = {}

            for (let i of paraString) {
                paraObj[i.substring(0, i.indexOf("=")).toLowerCase()] = i.substring(i.indexOf("=") + 1, i.length)
            }

            if (typeof (paraObj) == "undefined") {
                return ""
            } else if (paras) {
                return paraObj[paras.toLowerCase()]
            } else {
                return paraObj
            }
        }
	}
};
</script>

